'use client';

import { Button, Card } from '@clickt/brand';
import { Link } from '@tanstack/react-router';
import { ArrowRight, Compass } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 surface-dotted">
      <Card padding="lg" className="max-w-md w-full text-center space-y-4">
        <span
          aria-hidden
          className="mx-auto grid h-12 w-12 place-items-center rounded-pill bg-electric/10 text-electric"
        >
          <Compass className="h-5 w-5" />
        </span>
        <h1 className="font-display text-display-3 font-bold text-midnight leading-tight">
          Not found.
        </h1>
        <p className="text-body-md text-cool-gray leading-relaxed">
          That page doesn't exist (or you don't have access). Head back to the overview.
        </p>
        <Button asChild size="md">
          <Link to="/app">
            Back to overview
            <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </Button>
      </Card>
    </div>
  );
}
